import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ApiCalls } from '../../api/api';
import { GET_CALENDARS } from '../../constants/queryKeys';
import { Calendar } from '../../api/generated/data-contracts';

export const DEFAULT_CALENDAR_KEY = 'default';

export const useCalendars = (
    options?: Omit<UseQueryOptions<Calendar[], unknown, Calendar[], string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) => {
    return useQuery({
        queryKey: [GET_CALENDARS],
        queryFn: () => ApiCalls.configurationCalendarsList().then(res => [{ id: DEFAULT_CALENDAR_KEY, name: 'Default' }, ...res.data]),
        suspense: true,
        ...(options || {}),
    });
};
